import axios from 'axios';
import { savedLoginPath } from "./savedRoutes";
import store from '../redux/store';
import { logout } from '../redux/slices/authSlice';
import { notifyError } from '../helper/notify';
import { API_BASE_URL } from './apiConfig';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// =============================
// Attach token to requests
// =============================
api.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.auth?.token;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

// =============================
// Handle token expiry
// =============================
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Prevent multiple toasts
      if (!window.__tokenExpiredHandled) {
        window.__tokenExpiredHandled = true;

        // Save current page before logout so login can redirect back here —
        // same convention used by the other logout paths in the app.
        const currentPath = window.location.pathname + window.location.search;
        const isAdminArea = currentPath.startsWith('/admin');
        sessionStorage.setItem(isAdminArea ? 'lastAdminPage' : 'lastUserPage', currentPath);

        // Dispatch logout
        store.dispatch(logout());

        // Show toast once
        notifyError('Your session has expired. Please log in again.', {
          toastId: 'token-expired',
        });

        // Redirect after short delay
        setTimeout(() => {
          window.__tokenExpiredHandled = false;
          // The admin login route is "/admin" itself — there is no "/admin/login" route.
          window.location.href = savedLoginPath(isAdminArea);
        }, 1500);
      }
    }

    return Promise.reject(error.response?.data || error.message);
  }
);

export default api;
